import React from 'react';
import WithValidation, { IInputElementBaseProps, IBaseInputElement } from './input-validator/InputValidator';

interface CheckboxProps extends IInputElementBaseProps<boolean> {
  content?: string | JSX.Element;
}

export interface CheckboxElement extends IBaseInputElement {}

function _Checkbox(props: CheckboxProps) {
  return (
    <div
      className={`checkbox-v2 ${props.disabled ? 'disabled' : ''} ${props.value ? 'selected' : ''}`}
      onClick={e => !props.disabled && props.onChange(!props.value, e)}
    >
      <div
        className="box"
        tabIndex={0}
        onBlur={props.onBlur}
        onKeyPress={e => e.key === ' ' && !props.disabled && props.onChange(!props.value)}
      >
        {props.value && <i className={`gik-icon-v2 icon-v2-check`}></i>}
      </div>

      {props.content && <span className="text">{props.content}</span>}
    </div>
  );
}

export default WithValidation<CheckboxElement, React.PropsWithChildren<CheckboxProps>, boolean>(_Checkbox);
